import React from 'react';

interface AuthShellProps {
  children: React.ReactNode;
  /**
   * Quando `true`, encaixa o conteudo num viewport flex centralizado
   * com padding 40px (desktop) / 20px (mobile). Use `false` se a tela
   * controla seu proprio layout (ex: full-bleed customizado).
   */
  centered?: boolean;
  className?: string;
}

/**
 * Wrapper escopado das telas publicas de autenticacao. Aplica:
 *  - Tokens da paleta cream/terracotta (sobrescreve --bg-0, --brand-500,
 *    --text-* etc) via CSS em `.auth-shell` - sem vazar pra fora.
 *  - Fonte sans Geist por padrao; serif Instrument e mono Geist Mono
 *    disponiveis via classes utilitarias (.auth-display, .auth-eyebrow,
 *    .auth-microcopy) ou tokens (var(--auth-font-*)).
 *  - Dotted bg grid 28px no fundo.
 *
 * Render server-side (sem 'use client'); pode envolver Server Components.
 *
 * Doc: docs/AUTH_LAYOUT.md (a criar). Origem visual:
 * `templates/Login com Google/`.
 */
export function AuthShell({
  children,
  centered = true,
  className,
}: AuthShellProps) {
  const root = ['auth-shell', className].filter(Boolean).join(' ');
  if (!centered) {
    return <div className={root}>{children}</div>;
  }
  return (
    <div className={root}>
      <div className="auth-shell__viewport">{children}</div>
    </div>
  );
}
